import { MaterialService } from './material.service';
import { GroupFormations } from './../model/group_formations.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { GroupFormationsList } from '../model/groupFormationsList';

@Injectable()
export class GroupFormationsService extends KiwixiService {
    apiGroups = environment.server + 'group_formations/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getGroups(params: HttpParams): Observable<GroupFormationsList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<GroupFormationsList>(this.apiGroups + '?salt=' + Math.random(), {
            headers: header,
            params: params,
        }).
            pipe(
                catchError(this.handleErrorObservable<GroupFormationsList>(`getGroupFormations`))
            );
    }

    getGroupWithUrl(_url): Observable<GroupFormations[]> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<GroupFormations[]>(_url, {
            headers: header
        }).
            pipe(
                catchError(this.handleErrorObservable<GroupFormations[]>(`getGroupFormationWithUrl`))
            );
    }

    postGroup(name): Observable<GroupFormations> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.post<GroupFormations>(this.apiGroups, { name: name, slug: name }, {
            headers: header,
        }).
            pipe(
                catchError(this.handleErrorObservable<GroupFormations>(`getGroupFormations`))
            );
    }

    patchGroup(id, params): Observable<GroupFormations> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.patch<GroupFormations>(this.apiGroups + id  + '/?salt=' + Math.random(), params, {
            headers: header,
        }).
            pipe(  
                catchError(this.handleErrorObservable<any>(`patchCompany`))
            );
    }
}

